module.exports = __webpack_public_path__ + "static/img/3.c450dc0b.jpg";